import styled from "styled-components";

const FormContainer = styled.div.attrs({
  className: "w-full flex flex-col gap-4 mt-6 mb-5",
})``;

const HalfWidth = styled.div.attrs({
  className: "sm:w-full md:w-6/12 flex flex-col gap-4",
})``;

export default {
  FormContainer,
  HalfWidth,
};
